import type { MatchPublicView } from '../api-client.js';

export type SeatLabelMap = Record<string, string>;

export function buildSeatLabels(
  match: MatchPublicView,
  userSeatId: string | null,
): SeatLabelMap {
  const labels: SeatLabelMap = {};
  for (const seat of match.seats) {
    labels[seat.id] = seat.id === userSeatId ? 'You' : 'Opponent';
  }
  return labels;
}

export function humanizeSeatRefs(text: string, labels: SeatLabelMap): string {
  let out = text;
  for (const [seatId, label] of Object.entries(labels)) {
    if (!seatId) continue;
    // Possessive first ("<seatId>'s Forward Pocket"), with correct grammar
    // for the second person — "You's" is not a thing.
    const possessive = label === 'You' ? 'your' : `${label}'s`;
    out = out.split(`${seatId}'s`).join(possessive);
    out = out.split(seatId).join(label);
  }
  return out;
}
